import React, { useEffect, useState, useRef } from "react";
import { Box } from "@mui/material";
import ThreeJSModule from "./modules/ThreejsModule";
import LandingComp from "./Components/LandingComp";
import CameraCapture from "./Components/CameraCapture";

function App() {
  const container = useRef(null);
  const [arStarted, setArStarted] = useState(false);
  const [threeJSModule, setThreeJSModule] = useState(false);
  useEffect(() => {
    const three = new ThreeJSModule({
      container: container.current,
    });
    setThreeJSModule(three);
    return () => {
      threeJSModule.stop();
    };
  }, []);

  const startAR = () => {
    threeJSModule.start();
  };

  return (
    <>
      {arStarted && <CameraCapture />}
      <Box
        component='div'
        sx={{
          width: "100%",
          height: "100%",
          position: "fixed",
          zIndex: "1",
        }}
        ref={container}
        id='container'
      ></Box>
      {!arStarted && (
        <LandingComp startAR={startAR} setArStarted={setArStarted} />
      )}
    </>
  );
}

export default App;
